<h1 mat-dialog-title>Review Product Data Files</h1>
<mat-dialog-content>
  @if (isLoading) {
    <div style="display: flex; justify-content: center; padding: 24px">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!isLoading && result) {
    <div>
      <div class="summary">
        @if (hasBlockers) {
          <span class="cannot-proceed-block-chip">
            <mat-icon>error</mat-icon>
            <strong>Cannot proceed</strong>
          </span>
        }
        <span><strong>Total:</strong> {{ result.summary.totalFiles }}</span>
        @if (result.summary.missingCount > 0) {
          <span class="cannot-proceed-chip">
            <mat-icon>error</mat-icon>
            <strong>Missing:</strong> {{ result.summary.missingCount }}
          </span>
        }
        @if (result.summary.cannotProceedCount > 0) {
          <span class="cannot-proceed-chip">
            <mat-icon>error</mat-icon>
            <strong>Cannot proceed:</strong> {{ result.summary.cannotProceedCount }}
          </span>
        }
      </div>

      @if (hasBlockers) {
        <div class="blockers-banner">
          <mat-icon>error</mat-icon>
          <div>
            <strong>Blockers:</strong>
            {{ result.summary.missingCount }} product-data file{{ result.summary.missingCount === 1 ? '' : 's' }} missing on S3.
            Regenerate via the Create Product Data wizard (step 3) before creating the collection.
          </div>
        </div>
      }

      @if (result.cannotProceed.length > 0) {
        <div class="cannot-proceed-banner">
          <mat-icon>error</mat-icon>
          <div>
            <strong>Cannot proceed:</strong>
            {{ result.cannotProceed.length }} product{{ result.cannotProceed.length === 1 ? '' : 's' }}
            missing the identifier configured by the current Product Data Filename Convention.
            Configure the missing identifier on each product, or update the convention, before
            creating the collection.
          </div>
        </div>
      }

      <table mat-table [dataSource]="result.rows" class="asset-table">
        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef>Product</th>
          <td mat-cell *matCellDef="let row" class="product-cell" [class.missing-row]="!row.state.exists">
            {{ getProductIdentifier(row) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="format">
          <th mat-header-cell *matHeaderCellDef>Format</th>
          <td mat-cell *matCellDef="let row" [class.missing-row]="!row.state.exists">
            {{ row.origin.format.extension }}
          </td>
        </ng-container>
        <ng-container matColumnDef="filePath">
          <th mat-header-cell *matHeaderCellDef>File Path</th>
          <td
            mat-cell
            *matCellDef="let row"
            class="file-path"
            [class.missing-row]="!row.state.exists"
            [matTooltip]="row.storage.uri"
          >
            {{ getFileName(row.storage.key) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="exists">
          <th mat-header-cell *matHeaderCellDef>Exists</th>
          <td mat-cell *matCellDef="let row" [class.missing-row]="!row.state.exists">
            @if (row.state.exists) {
              <mat-icon class="exists-icon">check_circle</mat-icon>
            }
            @if (!row.state.exists) {
              <mat-icon class="missing-icon">cancel</mat-icon>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      @if (result.cannotProceed.length > 0) {
        <div class="cannot-proceed-section">
          <h3 class="cannot-proceed-title">
            <mat-icon>error</mat-icon>
            Cannot proceed
          </h3>
          <table mat-table [dataSource]="result.cannotProceed" class="cannot-proceed-table">
            <ng-container matColumnDef="product">
              <th mat-header-cell *matHeaderCellDef>Product</th>
              <td mat-cell *matCellDef="let entry">
                {{ entry.product.identifiers.barcode
                  || entry.product.identifiers.reference
                  || entry.product.identifiers.description
                  || entry.product.id }}
              </td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th mat-header-cell *matHeaderCellDef>Reason</th>
              <td mat-cell *matCellDef="let entry">{{ entry.reason }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="cannotProceedColumns"></tr>
            <tr mat-row *matRowDef="let entry; columns: cannotProceedColumns"></tr>
          </table>
        </div>
      }
    </div>
  }

  @if (!isLoading && hasErrored) {
    <div class="load-error">
      <mat-icon color="warn">error</mat-icon>
      <span>Failed to load product data files preview.</span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
